import { render, staticRenderFns } from "./newBuildMsgDialog.vue?vue&type=template&id=0b482cb5&scoped=true&"
import script from "./newBuildMsgDialog.vue?vue&type=script&lang=js&"
export * from "./newBuildMsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./newBuildMsgDialog.vue?vue&type=style&index=0&id=0b482cb5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b482cb5",
  null
  
)

export default component.exports